// extracted by mini-css-extract-plugin
module.exports = {"root":"_2D2KF","listElement":"qF50j"};